"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _striptags = _interopRequireDefault(require("striptags"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _card = _interopRequireDefault(require("./card"));
var _concept = _interopRequireDefault(require("./concept"));
var _translation = _interopRequireDefault(require("./translation"));
var _user = _interopRequireDefault(require("./user"));
var _word = _interopRequireDefault(require("./word"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _deck_rulebook = _interopRequireDefault(require("./deck_rulebook"));
var _card_rule = _interopRequireDefault(require("./card_rule"));
var _exercise = _interopRequireDefault(require("./exercise"));
var _deck_state = _interopRequireDefault(require("./deck_state"));
var _level = _interopRequireDefault(require("./level"));
var _feed_entry_media_item = _interopRequireDefault(require("./feed_entry_media_item"));
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _constants = require("@seedlang/constants");
var _deck_grammar_concept = _interopRequireDefault(require("./deck_grammar_concept"));
var _xp_breakdown = _interopRequireDefault(require("./xp_breakdown"));
var _src = require("@seedlang/utils/src");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89, _descriptor90, _descriptor91, _descriptor92, _descriptor93, _descriptor94, _descriptor95, _descriptor96, _descriptor97; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Deck = (_dec = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_card_rule["default"]))), _dec2 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec3 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_concept["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_translation["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_deck_rulebook["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec9 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_card["default"]))), _dec10 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_word["default"]))), _dec11 = (0, _serializr.serializable)((0, _serializr.object)(_word["default"])), _dec12 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_exercise["default"]))), _dec13 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_deck_grammar_concept["default"]))), _dec14 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec15 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec16 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec17 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_xp_breakdown["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function Deck() {
    var _this;
    _classCallCheck(this, Deck);
    _this = _callSuper(this, Deck);
    // there is also a deck_basic.js
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "deckType", _descriptor2, _this);
    _initializerDefineProperty(_this, "cardsCount", _descriptor3, _this);
    _initializerDefineProperty(_this, "reviewCardsCount", _descriptor4, _this);
    _initializerDefineProperty(_this, "pastDueCount", _descriptor5, _this);
    _initializerDefineProperty(_this, "progressCurrent", _descriptor6, _this);
    _initializerDefineProperty(_this, "retiredCount", _descriptor7, _this);
    _initializerDefineProperty(_this, "userDecksCount", _descriptor8, _this);
    _initializerDefineProperty(_this, "reviewed1", _descriptor9, _this);
    _initializerDefineProperty(_this, "reviewed2", _descriptor10, _this);
    _initializerDefineProperty(_this, "reviewed3", _descriptor11, _this);
    _initializerDefineProperty(_this, "name", _descriptor12, _this);
    _initializerDefineProperty(_this, "archived", _descriptor13, _this);
    _initializerDefineProperty(_this, "useDailyGoal", _descriptor14, _this);
    _initializerDefineProperty(_this, "dailyGoal", _descriptor15, _this);
    _initializerDefineProperty(_this, "rating", _descriptor16, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor17, _this);
    _initializerDefineProperty(_this, "languagesString", _descriptor18, _this);
    _initializerDefineProperty(_this, "descriptionMd", _descriptor19, _this);
    _initializerDefineProperty(_this, "grammarDescriptionMd", _descriptor20, _this);
    _initializerDefineProperty(_this, "grammarDescription", _descriptor21, _this);
    _initializerDefineProperty(_this, "treeNodeDescriptionMd", _descriptor22, _this);
    _initializerDefineProperty(_this, "treeNodeGrammarDescriptionMd", _descriptor23, _this);
    _initializerDefineProperty(_this, "treeNodeGrammarDescription", _descriptor24, _this);
    _initializerDefineProperty(_this, "openAccess", _descriptor25, _this);
    _initializerDefineProperty(_this, "webPublished", _descriptor26, _this);
    _initializerDefineProperty(_this, "mobilePublished", _descriptor27, _this);
    _initializerDefineProperty(_this, "imageUrl", _descriptor28, _this);
    _initializerDefineProperty(_this, "finishedUserDecksCount", _descriptor29, _this);
    _initializerDefineProperty(_this, "cumulativeRatings", _descriptor30, _this);
    _initializerDefineProperty(_this, "ratingsCount", _descriptor31, _this);
    _initializerDefineProperty(_this, "onboardingOption", _descriptor32, _this);
    _initializerDefineProperty(_this, "guestUserDecksCount", _descriptor33, _this);
    _initializerDefineProperty(_this, "registeredUserDecksCount", _descriptor34, _this);
    _initializerDefineProperty(_this, "proUserDecksCount", _descriptor35, _this);
    _initializerDefineProperty(_this, "finishedGuestUserDecksCount", _descriptor36, _this);
    _initializerDefineProperty(_this, "finishedRegisteredUserDecksCount", _descriptor37, _this);
    _initializerDefineProperty(_this, "finishedProUserDecksCount", _descriptor38, _this);
    _initializerDefineProperty(_this, "convertToRegistrationCount", _descriptor39, _this);
    _initializerDefineProperty(_this, "convertToProCount", _descriptor40, _this);
    _initializerDefineProperty(_this, "percentageFinished", _descriptor41, _this);
    _initializerDefineProperty(_this, "percentageGuestFinished", _descriptor42, _this);
    _initializerDefineProperty(_this, "percentageRegisteredFinished", _descriptor43, _this);
    _initializerDefineProperty(_this, "percentageProFinished", _descriptor44, _this);
    _initializerDefineProperty(_this, "initialDeckBeforePurchaseCount", _descriptor45, _this);
    _initializerDefineProperty(_this, "sampleVocabDeck", _descriptor46, _this);
    _initializerDefineProperty(_this, "totalPoints", _descriptor47, _this);
    _initializerDefineProperty(_this, "averagePoints", _descriptor48, _this);
    _initializerDefineProperty(_this, "ourRating", _descriptor49, _this);
    _initializerDefineProperty(_this, "triviaDeckOutOfSynch", _descriptor50, _this);
    _initializerDefineProperty(_this, "convertedToPro", _descriptor51, _this);
    _initializerDefineProperty(_this, "conversionPercentage", _descriptor52, _this);
    _initializerDefineProperty(_this, "firstDecksCount", _descriptor53, _this);
    _initializerDefineProperty(_this, "wordsCount", _descriptor54, _this);
    _initializerDefineProperty(_this, "wordsList", _descriptor55, _this);
    _initializerDefineProperty(_this, "hasExternalContent", _descriptor56, _this);
    _initializerDefineProperty(_this, "showDeckGrammarCard", _descriptor57, _this);
    _initializerDefineProperty(_this, "color", _descriptor58, _this);
    _initializerDefineProperty(_this, "defaultReviewDeck", _descriptor59, _this);
    _initializerDefineProperty(_this, "reviewsFilterRetired", _descriptor60, _this);
    _initializerDefineProperty(_this, "reviewsFilterCardTypeId", _descriptor61, _this);
    _initializerDefineProperty(_this, "reviewsFilterDifficultyScore", _descriptor62, _this);
    _initializerDefineProperty(_this, "reviewsFilterCreatedAtDaysAgo", _descriptor63, _this);
    _initializerDefineProperty(_this, "reviewsFilterCreatedAtBeforeAfter", _descriptor64, _this);
    _initializerDefineProperty(_this, "reviewsFilterReviewAfterDaysFromNow", _descriptor65, _this);
    _initializerDefineProperty(_this, "reviewsFilterReviewAfterBeforeAfter", _descriptor66, _this);
    _initializerDefineProperty(_this, "reviewsFilterDue", _descriptor67, _this);
    _initializerDefineProperty(_this, "reviewsFilterSort", _descriptor68, _this);
    _initializerDefineProperty(_this, "reviewsFilterDifficultyLabel", _descriptor69, _this);
    _initializerDefineProperty(_this, "vocabTriadWordId", _descriptor70, _this);
    _initializerDefineProperty(_this, "validSetup", _descriptor71, _this);
    _initializerDefineProperty(_this, "treeNodesCount", _descriptor72, _this);
    _initializerDefineProperty(_this, "treeNodeIds", _descriptor73, _this);
    _initializerDefineProperty(_this, "conjugationWordId", _descriptor74, _this);
    _initializerDefineProperty(_this, "conjugationTenseId", _descriptor75, _this);
    _initializerDefineProperty(_this, "hideVocabTriadIntro", _descriptor76, _this);
    _initializerDefineProperty(_this, "firstTreeNodePosition", _descriptor77, _this);
    _initializerDefineProperty(_this, "firstTreeNodeName", _descriptor78, _this);
    _initializerDefineProperty(_this, "grammarTipsCount", _descriptor79, _this);
    _initializerDefineProperty(_this, "grammarDescriptionOverride", _descriptor80, _this);
    _initializerDefineProperty(_this, "selectedCardRules", _descriptor81, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor82, _this);
    _initializerDefineProperty(_this, "updatedAt", _descriptor83, _this);
    _initializerDefineProperty(_this, "user", _descriptor84, _this);
    _initializerDefineProperty(_this, "concept", _descriptor85, _this);
    _initializerDefineProperty(_this, "translation", _descriptor86, _this);
    _initializerDefineProperty(_this, "deckRulebook", _descriptor87, _this);
    _initializerDefineProperty(_this, "level", _descriptor88, _this);
    _initializerDefineProperty(_this, "cards", _descriptor89, _this);
    _initializerDefineProperty(_this, "words", _descriptor90, _this);
    _initializerDefineProperty(_this, "word", _descriptor91, _this);
    _initializerDefineProperty(_this, "exercises", _descriptor92, _this);
    _initializerDefineProperty(_this, "deckGrammarConcepts", _descriptor93, _this);
    _initializerDefineProperty(_this, "reviewed1User", _descriptor94, _this);
    _initializerDefineProperty(_this, "reviewed2User", _descriptor95, _this);
    _initializerDefineProperty(_this, "reviewed3User", _descriptor96, _this);
    _initializerDefineProperty(_this, "xpBreakdowns", _descriptor97, _this);
    _this.deckState = new _deck_state["default"](_this);
    return _this;
  }
  _inherits(Deck, _RootModel);
  return _createClass(Deck, [{
    key: "feedEntryMediaItems",
    get: function get() {
      var cards;
      if (this.deckTypeIsTriad) {
        cards = this.cards.filter(function (item) {
          return item.cardRule.cardType.slug === 'vocab_sentence_translate';
        });
      } else {
        cards = this.cards.filter(function (item) {
          return item.translation && item.translation.useInFeedEntry && item.cardRule.cardType.slug === 'comprehend';
        });
      }
      return cards.map(function (item) {
        return new _feed_entry_media_item["default"]({
          id: (0, _utils.createUuid)(),
          targetText: item.sentence.targetText,
          videoClip: item.translation.hasImage ? null : item.translation.feedEntryVideoClip,
          image: item.translation.image
        });
      });
    }
  }, {
    key: "conceptVideoClip",
    get: function get() {
      return this.concept.videoClip;
    }
  }, {
    key: "averageRating",
    get: function get() {
      return this.ratingsCount > 0 ? Math.round(this.cumulativeRatings / this.ratingsCount * 10) / 10 : 0;
    }
  }, {
    key: "combinedGrammarDescription",
    get: function get() {
      return this.hasGrammarDescription ? this.grammarDescription : this.treeNodeGrammarDescription;
    }
  }, {
    key: "combinedDescription",
    get: function get() {
      return this.hasDescription ? this.descriptionMd : this.treeNodeDescriptionMd;
    }
  }, {
    key: "mappedVocabWordsList",
    get: function get() {
      return (0, _utils.isPresent)(this.words) ? this.words.map(function (item) {
        return {
          id: item.id,
          name: item && item.targetTextWithDefiniteArticle,
          targetWithWordTypeParentInfinitiveAndSource: item && item.targetWithWordTypeParentInfinitiveAndSource
        };
      }) : [];
    }
  }, {
    key: "digitWordsList",
    get: function get() {
      return (0, _utils.isPresent)(this.words) && this.numberDeck ? this.words.map(function (item) {
        return item.formattedDigitSourceText;
      }) : [];
    }
  }, {
    key: "lastCard",
    get: function get() {
      return (0, _lodash.last)(this.cards);
    }
  }, {
    key: "deckRulebookSlug",
    get: function get() {
      return this.deckRulebook && this.deckRulebook.slug;
    }
  }, {
    key: "caughtUpCount",
    get: function get() {
      return this.reviewCardsCount - this.pastDueCount - this.retiredCount;
    }
  }, {
    key: "hasCombinedGrammarDescription",
    get: function get() {
      return (0, _utils.isPresent)((0, _striptags["default"])(this.combinedGrammarDescription));
    }
  }, {
    key: "deckTypeIsTriad",
    get: function get() {
      return this.deckType.match('triad');
    }
  }, {
    key: "translationAndComprehensionCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return ['comprehend', 'translate', 'vocab_word_translate', 'vocab_word_options', 'minimal_pair', 'sentence_pronounce', 'vocab_sentence_translate', 'trivia', 'number_translate'].includes(item.cardTypeSlug);
      });
    }
  }, {
    key: "exerciseCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return ['exercise'].includes(item.cardTypeSlug);
      });
    }
  }, {
    key: "vocabWordTranslateCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return item.cardTypeSlug === 'vocab_word_translate';
      });
    }
  }, {
    key: "hasCombinedDescription",
    get: function get() {
      return (0, _utils.isPresent)((0, _striptags["default"])(this.combinedDescription));
    }
  }, {
    key: "hasDescription",
    get: function get() {
      return (0, _utils.isPresent)((0, _striptags["default"])(this.descriptionMd));
    }
  }, {
    key: "hasGrammarDescription",
    get: function get() {
      return (0, _utils.isPresent)((0, _striptags["default"])(this.grammarDescriptionMd));
    }
  }, {
    key: "hasTreeNodeGrammarDescription",
    get: function get() {
      return (0, _utils.isPresent)((0, _striptags["default"])(this.treeNodeGrammarDescriptionMd));
    }
  }, {
    key: "conceptId",
    get: function get() {
      return (0, _utils.isPresent)(this.concept) ? this.concept.id : null;
    }
  }, {
    key: "cardTypes",
    get: function get() {
      return this.cards.map(function (item) {
        return item.cardType;
      });
    }
  }, {
    key: "triviaCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return item.cardType.slug === 'trivia';
      });
    }
  }, {
    key: "genderCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return item.cardType.slug === 'gender';
      });
    }
  }, {
    key: "pluralCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return item.cardType.slug === 'plural';
      });
    }
  }, {
    key: "numberCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return item.cardType.slug === 'number_options';
      });
    }
  }, {
    key: "conjugationCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return ['conjugation', 'conjugation-multiple-choice', 'conjugation-fill-in-blanks'].includes(item.cardType.slug);
      });
    }
  }, {
    key: "pronunciationCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return ['word_pronounce', 'minimal_pair', 'sentence_pronounce'].includes(item.cardType.slug);
      });
    }
  }, {
    key: "languageName",
    get: function get() {
      if (this.concept && this.concept.languageId) {
        return _constants.Languages[this.concept.languageId];
      } else if (this.languageId) {
        return _constants.Languages[this.languageId];
      }
      return 'German';
    }
  }, {
    key: "conjugationAndTranslationCards",
    get: function get() {
      return this.cards.filter(function (item) {
        return ['conjugation', 'vocab_sentence_translate', 'conjugation-multiple-choice', 'conjugation-fill-in-blanks', 'comprehend'].includes(item.cardType.slug);
      });
    }
  }, {
    key: "genderDeck",
    get: function get() {
      return this.deckRulebook && this.deckRulebook.slug === 'gender';
    }
  }, {
    key: "conjugationDeck",
    get: function get() {
      return this.deckRulebook && ['conjugation', 'conjugation-multiple-choice', 'conjugation-fill-in-blanks'].includes(this.deckRulebook.slug);
    }
  }, {
    key: "numberDeck",
    get: function get() {
      return this.deckRulebook && (this.deckRulebook.slug === 'number' || this.deckRulebook.slug === 'number-with-comprehension');
    }
  }, {
    key: "pronunciationDeck",
    get: function get() {
      var _this$deckRulebook;
      return ((_this$deckRulebook = this.deckRulebook) === null || _this$deckRulebook === void 0 ? void 0 : _this$deckRulebook.slug) && this.deckRulebook.slug.includes('pronunciation');
    }
  }, {
    key: "conjugationWithVideoDeck",
    get: function get() {
      var _this$deckRulebook2;
      return ((_this$deckRulebook2 = this.deckRulebook) === null || _this$deckRulebook2 === void 0 ? void 0 : _this$deckRulebook2.slug) && this.deckRulebook.slug.startsWith('conjugation-with-video');
    }
  }, {
    key: "pluralDeck",
    get: function get() {
      return this.deckRulebook && this.deckRulebook.slug === 'plural';
    }
  }, {
    key: "triviaDeck",
    get: function get() {
      return this.deckRulebook && this.deckRulebook.slug === 'trivia';
    }
  }, {
    key: "vocabDeck",
    get: function get() {
      return this.deckRulebook && this.deckRulebook.slug === 'vocab';
    }
  }, {
    key: "hasCards",
    get: function get() {
      return this.cards.length > 0;
    }
  }, {
    key: "numCards",
    get: function get() {
      return this.cards.length;
    }
  }, {
    key: "grammarTitle",
    get: function get() {
      return (0, _utils.isPresent)(this.concept) ? this.concept.displayNameLine1 : null;
    }
  }, {
    key: "isConcept",
    value: function isConcept(concept) {
      return concept && (0, _utils.isPresent)(this.concept) && this.concept.id === concept.id;
    }
  }, {
    key: "setPastDueCount",
    value: function setPastDueCount(pastDueCount) {
      this.pastDueCount = pastDueCount;
    }
  }, {
    key: "isTranslation",
    value: function isTranslation(translation) {
      return translation && (0, _utils.isPresent)(this.translation) && this.translation.id === translation.id;
    }
  }, {
    key: "hasAllTranslations",
    value: function hasAllTranslations(languageId) {
      return this.languagesString && (0, _utils.isPresent)(this.languagesString.match(languageId));
    }
  }, {
    key: "sentenceWords",
    get: function get() {
      var sentenceWords = this.cards.filter(function (card) {
        var _card$cardType$name;
        return (_card$cardType$name = card.cardType.name) === null || _card$cardType$name === void 0 ? void 0 : _card$cardType$name.includes('Sentence');
      }).map(function (card) {
        return card.translation.wordAssociations.map(function (wa) {
          return wa.word.root ? wa.word : wa.word.rootWord;
        });
      }).flat().filter(function (word) {
        return word && (word.isNoun || word.isAdjective || word.isVerb || word.isAdverb);
      });
      return sentenceWords.filter(function (item, i) {
        return sentenceWords.map(function (item) {
          return item.id;
        }).indexOf(item.id) === i;
      });
    }
  }, {
    key: "xpBreakdownToday",
    get: function get() {
      var today = new Date();
      today.setUTCHours(0, 0, 0, 0); // Set to midnight UTC for today

      var tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      // Filter xpBreakdowns to find the one that occurred today
      return this.xpBreakdowns.find(function (xpBreakdown) {
        var occurredAtDate = new Date(xpBreakdown.occurredAtDatetimeUtc0.date);
        return occurredAtDate >= today && occurredAtDate < tomorrow;
      });
    }
  }, {
    key: "effectiveDailyGoal",
    get: function get() {
      if ((0, _src.isBlank)(this.xpBreakdownToday)) {
        if (this.pastDueCount < this.dailyGoal) {
          return this.pastDueCount;
        }
        return this.dailyGoal;
      }
      return this.xpBreakdownToday.dailyGoal;
    }
  }, {
    key: "reviewedToday",
    get: function get() {
      return (0, _utils.isPresent)(this.xpBreakdownToday) ? this.xpBreakdownToday.count : 0;
    }
  }, {
    key: "remainingDailyGoal",
    get: function get() {
      if ((0, _src.isBlank)(this.dailyGoal)) {
        return null;
      }
      return Math.max(0, this.effectiveDailyGoal - this.reviewedToday);
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "deckType", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "reviewCardsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pastDueCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "progressCurrent", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "retiredCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "userDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "reviewed1", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "reviewed2", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "reviewed3", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "archived", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "useDailyGoal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "dailyGoal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "rating", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "languagesString", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "descriptionMd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionMd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "grammarDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "treeNodeDescriptionMd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "treeNodeGrammarDescriptionMd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "treeNodeGrammarDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "openAccess", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "webPublished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "mobilePublished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "finishedUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "cumulativeRatings", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "ratingsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "onboardingOption", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "guestUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "registeredUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "proUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "finishedGuestUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "finishedRegisteredUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "finishedProUserDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "convertToRegistrationCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "convertToProCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "percentageFinished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "percentageGuestFinished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "percentageRegisteredFinished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "percentageProFinished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "initialDeckBeforePurchaseCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "sampleVocabDeck", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "totalPoints", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "averagePoints", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "ourRating", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "triviaDeckOutOfSynch", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "convertedToPro", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "conversionPercentage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "firstDecksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "wordsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "wordsList", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "hasExternalContent", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "showDeckGrammarCard", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "color", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "defaultReviewDeck", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterRetired", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterCardTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterDifficultyScore", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterCreatedAtDaysAgo", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterCreatedAtBeforeAfter", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterReviewAfterDaysFromNow", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterReviewAfterBeforeAfter", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterDue", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterSort", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "reviewsFilterDifficultyLabel", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "vocabTriadWordId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "validSetup", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "treeNodesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "treeNodeIds", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "conjugationWordId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "conjugationTenseId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "hideVocabTriadIntro", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "firstTreeNodePosition", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "firstTreeNodeName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "grammarTipsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "grammarDescriptionOverride", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "selectedCardRules", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "user", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "concept", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "translation", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "deckRulebook", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "level", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "cards", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor90 = _applyDecoratedDescriptor(_class.prototype, "words", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor91 = _applyDecoratedDescriptor(_class.prototype, "word", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor92 = _applyDecoratedDescriptor(_class.prototype, "exercises", [_mobx.observable, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor93 = _applyDecoratedDescriptor(_class.prototype, "deckGrammarConcepts", [_mobx.observable, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor94 = _applyDecoratedDescriptor(_class.prototype, "reviewed1User", [_mobx.observable, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor95 = _applyDecoratedDescriptor(_class.prototype, "reviewed2User", [_mobx.observable, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor96 = _applyDecoratedDescriptor(_class.prototype, "reviewed3User", [_mobx.observable, _dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor97 = _applyDecoratedDescriptor(_class.prototype, "xpBreakdowns", [_mobx.observable, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "feedEntryMediaItems", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "feedEntryMediaItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conceptVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conceptVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "averageRating", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "averageRating"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "combinedGrammarDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "combinedGrammarDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "combinedDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "combinedDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mappedVocabWordsList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mappedVocabWordsList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "digitWordsList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "digitWordsList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckRulebookSlug", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckRulebookSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "caughtUpCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "caughtUpCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCombinedGrammarDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCombinedGrammarDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckTypeIsTriad", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckTypeIsTriad"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translationAndComprehensionCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translationAndComprehensionCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabWordTranslateCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabWordTranslateCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCombinedDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCombinedDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasGrammarDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasGrammarDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTreeNodeGrammarDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTreeNodeGrammarDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conceptId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conceptId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTypes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTypes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pluralCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pluralCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conjugationCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conjugationCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pronunciationCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pronunciationCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conjugationAndTranslationCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conjugationAndTranslationCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conjugationDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conjugationDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pronunciationDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pronunciationDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conjugationWithVideoDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conjugationWithVideoDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pluralDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pluralDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "grammarTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "grammarTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPastDueCount", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setPastDueCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sentenceWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sentenceWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "xpBreakdownToday", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "xpBreakdownToday"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "effectiveDailyGoal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "effectiveDailyGoal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewedToday", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewedToday"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingDailyGoal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "remainingDailyGoal"), _class.prototype), _class);
var _default = exports["default"] = Deck;